import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Spinner, Alert } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import { useNavigate } from "react-router-dom";
import "../styles/DownloadsPage.css";
import axios from "axios";

const DownloadsPage = () => {
  const navigate = useNavigate();
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));
  const [downloads, setDownloads] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Define the fixed order of categories
  const categoryOrder = [
    "Membership Forms",
    "Accredited Programs",
    "IJOT",
    "Peer Review Process",
    "notes&certificates",
    "Datas",
    "notes and certificates",
    "IJOTPromo",
    "Elections",
    "laws",
    "Membership",
    "Programs",
    "IJOT1",
    "provisionalmembershipexamiv",
    "BOT Programs",
    "newsletter",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      if (currentToken !== tokenState) {
        setTokenState(currentToken);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [tokenState]);

  useEffect(() => {
    fetchDownloads();
  }, []);

  const fetchDownloads = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.get(
        `${process.env.REACT_APP_BASEURL}/public/downloads/category/all`
      );

      if (response.data.success) {
        // Group downloads by category
        const groupedDownloads = response.data.data.reduce((acc, item) => {
          if (!acc[item.category]) {
            acc[item.category] = [];
          }
          acc[item.category].push(item);
          return acc;
        }, {});
        setDownloads(groupedDownloads);
      } else {
        throw new Error(response.data.message);
      }
    } catch (err) {
      setError(err.message || "Failed to fetch downloads");
      console.error("Error fetching downloads:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (download) => {
    try {
      if (download.fileType === "url") {
        window.open(download.fileUrl, "_blank");
      } else if (download.fileType === "pdf") {
        // For PDF files, open in new tab or download based on browser behavior
        window.open(download.fileUrl, "_blank");
      } else {
        // For other file types, force download
        const a = document.createElement("a");
        a.href = download.fileUrl;
        a.download = download.fileName || "download";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    } catch (err) {
      console.error("Download failed:", err);
      alert("Failed to download file. Please try again.");
    }
  };

  const handleMemberLogin = () => {
    navigate("/member-login");
  };

  const handleEdcclogin = () => {
    navigate("/edcc-login");
  };

  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">
              All India Occupational Therapists' Association
            </h1>
            {!tokenState && (
              <div className="hero-buttons">
                <button className="glass-button" onClick={handleMemberLogin}>
                  Member Login
                </button>
                <button className="glass-button" onClick={handleEdcclogin}>
                  Ergonomic Certificate login
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container">
          <section className="download-content-section">
            <Container>
              <h2 className="downloads-heading">Downloads</h2>
              {loading ? (
                <div className="text-center py-5">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </div>
              ) : error ? (
                <Alert variant="danger" className="my-3">
                  {error}
                </Alert>
              ) : Object.keys(downloads).length === 0 ? (
                <div className="text-center no-data-message py-5">
                  <h5 className="text-muted">
                    No downloads available at the moment.
                  </h5>
                  <p className="text-muted">
                    Please check back later for updates.
                  </p>
                </div>
              ) : (
                // Render categories in the specified order
                categoryOrder.map(
                  (category) =>
                    downloads[category] &&
                    downloads[category].length > 0 && (
                      <React.Fragment key={category}>
                        <Row className="mb-2">
                          <Col>
                            <h5 className="text-start section-subtitle">
                              {category}
                            </h5>
                          </Col>
                        </Row>
                        <Row className="download-list-row">
                          <Col md={6}>
                            <ul className="download-list">
                              {downloads[category]
                                .slice(
                                  0,
                                  Math.ceil(downloads[category].length / 2)
                                )
                                .map((item) => (
                                  <li key={item.id}>
                                    <a
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleDownload(item);
                                      }}
                                    >
                                      {item.title}
                                    </a>
                                  </li>
                                ))}
                            </ul>
                          </Col>
                          {downloads[category].length >
                            Math.ceil(downloads[category].length / 2) && (
                            <Col md={6}>
                              <ul className="download-list">
                                {downloads[category]
                                  .slice(
                                    Math.ceil(downloads[category].length / 2)
                                  )
                                  .map((item) => (
                                    <li key={item.id}>
                                      <a
                                        href="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleDownload(item);
                                        }}
                                      >
                                        {item.title}
                                      </a>
                                    </li>
                                  ))}
                              </ul>
                            </Col>
                          )}
                        </Row>
                      </React.Fragment>
                    )
                )
              )}
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default DownloadsPage;
